
const swapArrayElements = (array, firstElementIndex, secondElementIndex) => {
  const arrayCopy = [...array];
  const buffer = arrayCopy[firstElementIndex];
  arrayCopy[firstElementIndex] = arrayCopy[secondElementIndex];
  arrayCopy[secondElementIndex] = buffer;
  return arrayCopy;
};

const getComputedStyle = (element) => window.getComputedStyle(element, null);

export default {
  name: 'BbTabs',
  props: {
    activeIndexFromInitState: {
      type: Object,
      default: undefined,
    },
    titles: {
      type: Array,
      default: () => [],
    },
    activeIndex: {
      type: [Number, String],
      default: 0,
    },
    value: [Number, String],
  },
  data() {
    return {
      activeTab: 0,
      tabsContainerWidth: null,
      menuItems: [],
      shadowWidth: null,
      tabsData: null,
      contentIndex: this.tabItem,
      titlesData: this.titles,
      menuButtonWidth: 24,
      shadowContainerPosition: null,
      isMounted: false,
    };
  },
  computed: {
    isMoreItemsMenuVisible() {
      return !!this.menuItems.length;
    },
    tabItem: {
      get() {
        return this.isValueProvided ? this.value : this.activeTab;
      },
      set(value) {
        if (this.isValueProvided) {
          this.$emit('input', value);
        } else {
          this.activeTab = value;
        }
      },
    },
    isValueProvided() {
      return typeof this.value !== 'undefined';
    },
  },
  watch: {
    activeIndexFromInitState(val) {
      if (this.isMounted) {
        this.setActiveItemByInitialIndex(val.index);
      }
    },
    tabItem(value) {
      this.tabsData.forEach((element) => {
        if (element.currentIndex === value) {
          this.contentIndex = element.contentIndex;
        }
      });
    },
  },
  methods: {
    setActiveItemByInitialIndex(val) {
      const tabData = this.tabsData.find((element) => element.initialIndex === val);
      if (this.menuItems.includes(tabData.tabName)) {
        this.menuItemClickHandler(this.menuItems.indexOf(tabData.tabName));
      } else {
        this.tabItem = this.titlesData.indexOf(tabData.tabName);
      }
    },
    calculateVisibleTabsCount() {
      this.menuItems = [];
      let isItemsCalculated = false;
      const tabsElements = [...this.$el.querySelectorAll('.v-tab')];
      tabsElements.length = this.titlesData.length;

      tabsElements.reduce((sumWidth, currentElement, index) => {
        const currentElementWidth = this.getCurrentElementWidth(currentElement);

        let newSum = isItemsCalculated ? sumWidth : sumWidth + currentElementWidth;
        if (this.isIemsWidthCalculated(newSum, sumWidth)) {
          isItemsCalculated = true;
          newSum = sumWidth;
          this.shadowWidth = `${this.tabsContainerWidth - newSum}px`;
          this.menuItems.push(this.titlesData[index]);
        }
        return newSum;
      }, 0);
    },

    getCurrentElementWidth(currentElement) {
      const computedStyle = getComputedStyle(currentElement);
      const currentElementWidth = computedStyle.getPropertyValue('width');
      const currentElementRightMargin = computedStyle.getPropertyValue('margin-right');
      const currentElementLeftMargin = computedStyle.getPropertyValue('margin-left');
      return parseInt(currentElementWidth, 10)
        + parseInt(currentElementRightMargin, 10)
        + parseInt(currentElementLeftMargin, 10);
    },

    swapAndUpdateTabsData(firstElementIndex, secondElementIndex) {
      const tabsDataFirstElementIndex = this.tabsData.find((element) =>
        element.currentIndex === (firstElementIndex)).currentIndex;
      const tabsDataSecondElementIndex = this.tabsData.find((element) =>
        element.tabName === this.menuItems[secondElementIndex]).currentIndex;

      this.tabsData.forEach((element, i) => {
        if (element.tabName === this.titlesData[firstElementIndex]) {
          this.tabsData[i].currentIndex = tabsDataSecondElementIndex;
        }
        if (element.tabName === this.menuItems[secondElementIndex]) {
          this.tabsData[i].currentIndex = tabsDataFirstElementIndex;
        }
      });
    },

    isIemsWidthCalculated(newSum, sumWidth) {
      return newSum > (this.tabsContainerWidth - this.menuButtonWidth) || newSum === sumWidth;
    },

    menuItemClickHandler(index) {
      let isItemsCalculated = false;
      const clickedTitleIndex = this.titlesData.indexOf(this.menuItems[index]);
      const tabsElements = [...this.$el.querySelectorAll('.v-tab')];
      tabsElements.length = this.titlesData.length;

      tabsElements.reduce((sumWidth, currentElement, tabIndex) => {
        const currentElementWidth = this.getCurrentElementWidth(currentElement);
        let newSum = isItemsCalculated ? sumWidth : sumWidth + currentElementWidth;
        if (this.isIemsWidthCalculated(newSum, sumWidth) && !isItemsCalculated) {
          isItemsCalculated = true;
          newSum = sumWidth;
          this.shadowWidth = `${this.tabsContainerWidth - newSum}px`;
          this.shadowContainerPosition = `${this.tabsContainerWidth - parseInt(this.shadowWidth, 10)}px`;
          this.swapAndUpdateTabsData(tabIndex, index);
          this.titlesData = swapArrayElements(this.titlesData, tabIndex, clickedTitleIndex);
          this.menuItems = this.titlesData.slice(tabIndex + 1, this.titlesData.length);
          this.tabItem = tabIndex;
          const contentItem = this.tabsData.find((element) =>
            element.tabName === this.titlesData[this.tabItem]);

          this.contentIndex = contentItem.contentIndex;
        }
        return newSum;
      }, this.getCurrentElementWidth(tabsElements[clickedTitleIndex]));
    },
  },
  created() {
    if (this.activeIndex) {
      this.tabItem = this.activeIndex;
    }
    this.tabsData = this.titlesData.reduce((result, currentElement, index) =>
      [
        ...result,
        {
          tabName: currentElement,
          contentIndex: index,
          currentIndex: index,
          initialIndex: index,
        },
      ], []);
    const contentItem = this.tabsData.find((element) =>
      element.tabName === this.titlesData[this.tabItem]);

    this.contentIndex = contentItem.contentIndex;
  },
  mounted() {
    this.isMounted = true;
    const tabsElement = this.$el.querySelector('.v-tabs');
    const computedStyle = getComputedStyle(tabsElement);
    const containerWidth = computedStyle.getPropertyValue('width');
    const rightContainerPadding = computedStyle.getPropertyValue('padding-right');
    const leftContainerPadding = computedStyle.getPropertyValue('padding-left');
    this.tabsContainerWidth = parseInt(containerWidth, 10)
      - parseInt(rightContainerPadding, 10)
      - parseInt(leftContainerPadding, 10);
    this.calculateVisibleTabsCount();
    this.shadowContainerPosition = `${this.tabsContainerWidth - parseInt(this.shadowWidth, 10)}px`;
    if (this.activeIndexFromInitStat?.index !== undefined) {
      this.setActiveItemByInitialIndex(this.activeIndexFromInitState.index);
    }
  },
};
